export enum TranslationLanguagesEnum {
  en_GB = 'en_GB',
  de_DE = 'de_DE',
  es_ES = 'es_ES',
  fr_FR = 'fr_FR',
  it_IT = 'it_IT',
  pl_PL = 'pl_PL',
}
